import React, { Component  } from 'react';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { withTranslation } from "react-i18next";
import {
  Col, Container, Row
} from "reactstrap";

import ComponentForm from "./ComponentForm";
import MaintenanceOrFeedbackHistoryList from "../MaintenanceOrFeedbackHistoryList";
import { createOrUpdateComponent } from "../../../../../redux/actions/componentActions";

export class ComponentCreateUpdate extends Component {

  handleCreate = data => {
    if ( data && Object.keys(data).length > 0 ) {
      data.component_type_id =
        data.component_type_id.value && data.component_type_id.value !== undefined
          ? data.component_type_id.value : data.component_type_id;

      data.data_status =
        data.data_status.value && data.data_status.value !== undefined
          ? data.data_status.value : data.data_status;

      data.last_action_taken_type =
        data.last_action_taken_type.value && data.last_action_taken_type.value !== undefined
          ? data.last_action_taken_type.value : data.last_action_taken_type;

      data.mean_time_between_failures =
        data.mean_time_between_failures && data.mean_time_between_failures !== undefined
          ? parseInt(data.mean_time_between_failures) : '';

      data.owner = data.owner ? parseInt(data.owner) : '';

      delete data.formType;
      delete data.updated_health_status;
      this.props.createOrUpdateComponent(data, this.props.history);
    }
  };

  renderField =
    ({
       input, placeholder, type, meta: { touched, error },
     }) => (
      <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
        <input {...input} placeholder={placeholder} type={type} />
        {touched && error && <span className="form__form-group-error">{error}</span>}
      </div>
    );

  renderMaintenanceOrFeedbackHistoryList = () => {
    const { selectedAsset, selectedComponent } = this.props;
    if (selectedAsset && Object.keys(selectedAsset).length > 0) {
      if (selectedComponent && Object.keys(selectedComponent).length > 0) {
        return <MaintenanceOrFeedbackHistoryList />;
      } else {
        return <React.Fragment />
      }
    } else {
      this.props.history.push('/settings/asset_management');
    }
  };

  build_selected_component = selectedComponent => {
    const { component_types } = this.props;
    let newSelectedComponent = JSON.parse(JSON.stringify(selectedComponent));

    if(newSelectedComponent && Object.keys(newSelectedComponent).length > 0) {
      if (newSelectedComponent.component_type_id) {
        if(component_types && Object.keys(component_types).length > 0) {
          component_types.filter(component_type => {
            if(component_type._id === newSelectedComponent.component_type_id) {
              newSelectedComponent.component_type_id = {
                value : component_type._id,
                label: component_type.name
              };
            }
            return component_type;
          });
        }
      }

      if (newSelectedComponent.data_status) {
        newSelectedComponent.data_status = {
          value: newSelectedComponent.data_status,
          label: newSelectedComponent.data_status.replace(/_/g, ' ')
        };
      }

      if (newSelectedComponent.last_action_taken_type) {
        newSelectedComponent.last_action_taken_type = {
          value: newSelectedComponent.last_action_taken_type,
          label: newSelectedComponent.last_action_taken_type.replace(/_/g, ' ')
        };
      }
    }

    return newSelectedComponent;
  };

  render () {
    const { t, selectedComponent } = this.props;
    let newSelectedComponent = this.build_selected_component(selectedComponent);

    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className="page-title">{t('asset_management.create_update_component.title')}</h3>
            <h3 className="page-subhead subhead">{t('asset_management.create_update_component.sub_title')}
            </h3>

            <ComponentForm
              form_data={newSelectedComponent}
              onSubmit={this.handleCreate}
              onCancel={() => {
                this.closeForm();
              }}
            />

            {this.renderMaintenanceOrFeedbackHistoryList()}

          </Col>
        </Row>
      </Container>
    );
  }
}

ComponentCreateUpdate.propTypes = {
  t: PropTypes.func.isRequired,
  createOrUpdateComponent: PropTypes.func.isRequired,
};

function mapStateToProps({ assetsManagement, component }) {
  return {
    selectedAsset: assetsManagement.selectedAsset,
    selectedComponent: component.selectedComponent,
    component_types: component.component_types,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      createOrUpdateComponent
    },
    dispatch
  );
}

export default withTranslation('common') (
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(ComponentCreateUpdate)
);
